import { Box, Button, Dialog, Text, TextField } from '@radix-ui/themes';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { CreateCardTypeRequest } from '../../model/Card-type.model';
import CardTypeService from '../../service/card-type-service/Card-type.service';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

interface CreateCardTypeModalProps {
  onSuccess: () => void;
}

const CreateCardTypeModal: React.FC<CreateCardTypeModalProps> = ({
  onSuccess,
}) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<CreateCardTypeRequest>({
    name: '',
  });
  const screens = useBreakpoint();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const submitData = {
        ...formData,
      };
      await CardTypeService.createCardType(submitData);
      toast.success('Tạo loại thẻ thành công!');
      onSuccess();
      setOpen(false);
      setFormData({
        name: '',
      });
    } catch (error: any) {
      console.error('Error creating card type:', error);
      toast.error(error.message || 'Có lỗi xảy ra khi tạo loại thẻ!');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'creditLimit') {
      const formattedValue = formatCurrency(value);
      setFormData((prev) => ({
        ...prev,
        [name]: Number(formattedValue.replace(/\./g, '')),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const formatCurrency = (value: string) => {
    const number = value.replace(/\D/g, '');
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>
        <Button
          color="indigo"
          variant="soft"
          className={`cursor-pointer ${screens.xs ? 'w-full' : ''}`}
        >
          Tạo loại thẻ mới
        </Button>
      </Dialog.Trigger>

      <Dialog.Content style={{ maxWidth: screens.xs ? '95%' : 700 }}>
        <Dialog.Title>Tạo loại thẻ</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Điền đầy đủ các thông tin
        </Dialog.Description>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Box className="space-y-4">
            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Tên loại thẻ <span className="text-red-500">*</span>
              </Text>
              <TextField.Root
                name="name"
                placeholder="Nhập tên loại thẻ"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
          </Box>

          <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-2 pt-4">
            <Dialog.Close>
              <Button
                variant="soft"
                color="gray"
                className="cursor-pointer w-full sm:w-auto"
              >
                Hủy
              </Button>
            </Dialog.Close>
            <Button
              color="indigo"
              variant="soft"
              type="submit"
              className="cursor-pointer w-full sm:w-auto"
            >
              Hoàn thành
            </Button>
          </div>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default CreateCardTypeModal;
